
export default vm => {
  return [
    {
      labelWidth: 110,
      data: [
        {
          name: "所属团队",
          key: "id",
          value: [],
          type: 4,
          isOrg: "",
          arr: [],
          clearable: true,
          async inputChange(value) {
            if(!value[0])return;
            vm.$http({
              url: `/buz/userBase/getByGroup?groupId=${value[0].id}`,
              type: "GET",
            }).then((res) => {
              vm.formData[0].data[1].value = "";
              vm.formData[0].data[1].arr = res.data.map(item => {
                return {
                  label: item.name,
                  value: item.id
                }
              })
            });
          },
          rules: [
            {
              required: true,
              message: "请选择所属团队"
            }
          ]
        },
        {
          name: "所属业务员",
          key: "agentId",
          value: "",
          type: 2,
          clearable: true,
          rules: [
            {
              required: true,
              message: "请选择所属业务员"
            }
          ],
          arr: []
        },
        {
          name: "重新分配原因",
          key: "reason",
          value: "",
          type: 1,
          modelType:'textarea',
          clearable: true,
          maxlength:100,
          showWordLimit:true,
          rules: [
            {
              required: true,
              message: "请输入原因"
            }
          ],
        }
      ],
    }
  ]
}